import {
  Directive,
  Input,
  OnChanges,
  QueryList,
  SimpleChanges,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { TranscludeDirective } from '@app/shared/directives/transclude.directive';
import { Subscription } from 'rxjs';

@Directive({
  selector: '[portalTransclusion]',
  standalone: false,
})
export class TransclusionDirective implements OnChanges {
  @Input('portalTransclusion')
  transcludeDirectives: QueryList<TranscludeDirective>;

  @Input('portalTransclusionContext')
  context?: any;

  @Input('portalTransclusionName')
  name: string;

  private subscription: Subscription | null = null;

  constructor(
    private template: TemplateRef<any>,
    private viewContainer: ViewContainerRef
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    const transcludeDirectives = changes.transcludeDirectives?.currentValue ?? this.transcludeDirectives;
    const context = changes.context?.currentValue ?? this.context;

    this.updateTemplate(transcludeDirectives, context);
  }

  ngOnInit(): void {
    this.updateTemplate(this.transcludeDirectives, this.context);
  }

  private updateTemplate(queryList: QueryList<TranscludeDirective>, context: any): void {
    this.subscription?.unsubscribe();
    this.subscription = queryList.changes.subscribe(() => {
      const template = queryList.find((item) => item.id === this.name)?.templateRef ?? this.template;

      this.viewContainer.clear();
      this.viewContainer.createEmbeddedView(template, context);
    });

    this.viewContainer.clear();
    this.viewContainer.createEmbeddedView(
      queryList.find((item) => item.id === this.name)?.templateRef ?? this.template,
      context
    );
  }
}
